module.exports = __webpack_public_path__ + "a206f8fa2eca8dc74713c6c1b9ff3fdb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/tsubomi-imamura.jpg
 ** module id = 430
 ** module chunks = 0
 **/